import { render, staticRenderFns } from "./DadosPadraoConvenio.vue?vue&type=template&id=66a03f4e"
import script from "./DadosPadraoConvenio.vue?vue&type=script&lang=js"
export * from "./DadosPadraoConvenio.vue?vue&type=script&lang=js"
import style0 from "./DadosPadraoConvenio.vue?vue&type=style&index=0&id=66a03f4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports